"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function isPluralI18nKey(lookupValue) {
  if ((0, _typeof2.default)(lookupValue) !== 'object') {
    return false;
  }

  var lookupKeys = Object.keys(lookupValue);
  var pluralKeysCount = 0;

  if (lookupKeys.length <= 3) {
    lookupKeys.forEach(function (key) {
      if (key === 'zero' || key === 'one' || key === 'other') {
        pluralKeysCount += 1;
      }
    });
  }

  return !!pluralKeysCount && pluralKeysCount === lookupKeys.length;
}

function isJSXKey(lookupValue) {
  return typeof lookupValue === 'function';
}

var _default = function _default(message) {
  var lookupValue = I18n.lookup(message);
  return !!(lookupValue && (typeof lookupValue === 'string' || isJSXKey(lookupValue))) || isPluralI18nKey(lookupValue);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/isValidI18nKey.js
// module id = 231
// module chunks = 209 210 211 212